import { css } from '@emotion/react';

export const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 32px;

    button {
      min-width: 96px;
      height: 44px;
      border: none;
      border-radius: 12px;
      background: #6c3bff;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s ease;
    }

    button:hover:not(:disabled) {
      background: #5a2ee6;
    }

    button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    span {
      color: #1f1f1f;
      font-weight: 600;
      font-size: 14px;
    }
  `,
};
